import React from "react";
import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../components/Global/OrderColumn";
import useItemType from "./useItemType";
import AddItemType from "./AddItemType";
import { Table } from "../../Global/Table";

const ItemType = () => {
  const {
    isCenter,
    isLoading,
    isFetching,
    tableFields,
    itemTypeList,
    isCVDChecked,
    itemTypeState,
    showEditModal,
    paginationOptions,
    getRow,
    refetch,
    handleSort,
    setIsCenter,
    handleDelete,
    handleSearch,
    handlePageSize,
    setIsCVDChecked,
    handlePagination,
    handleModalClick,
    handleDeleteModal,
    handleEditAction,
    handleClearClick,
    handleCVDChecked,
    handleExcelDownload,
    updateItemTypeFields,
    handleEditColumnsClick,
  } = useItemType();

  return (
    <div>
      <HeadingGroup
        title={"Item Types"}
        className={`pro-mb-4`}
        buttonTitle={itemTypeList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters
          handleClear={handleClearClick}
          searchInputProps={{ value: itemTypeState?.search , placeholder:"Search Name, Code, Services" }}
        />
        <Table
          multiSelect={false}
          data={itemTypeList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          assignIcon={
            <span className="material-symbols-outlined">download</span>
          }
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          clear={itemTypeState.clearSelection}
          perpage={itemTypeState?.currentPageSize}
          assignable={true}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          handleAssign={handleExcelDownload}
          assignText={"Download Excel"}
          deletable={itemTypeList?.data?.delete_permission}
          editable={itemTypeList?.data?.edit_permission}
          showCheckBox={true}
        />
        {itemTypeList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={itemTypeState?.currentPage}
            totalPageCount={Math.ceil(
              itemTypeList.data.total_count / itemTypeState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={itemTypeState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected item ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={itemTypeList?.data?.fields}
              moduleId={itemTypeList?.data?.module_id}
              updateData={updateItemTypeFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={itemTypeState?.showAddItemTypeModal}
          handleClose={handleModalClick}
          title={itemTypeState?.isEdit ? "Edit Item Type" : "Add Item type "}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddItemType
            isCenter={isCenter}
            isCVDChecked={isCVDChecked}
            refetch={refetch}
            setIsCenter={setIsCenter}
            setIsCVDChecked={setIsCVDChecked}
            handleCVDChecked={handleCVDChecked}
          />
        </ModalLayout>
      </div>
    </div>
  );
};

export default ItemType;
